import { ROUTE } from "../../../routes";
import SharedPropsService from "../../../SharedPropsService";
let phoneNumber = "";
export const updateMobileNumber = async (action, _datastore, { navigate, setDatastore, asyncStorage, goBack, instrumentTrack, ...props }) => {
    await instrumentTrack("UPDATE_MOBILE_NUMBER_CLICKED");
    if (!phoneNumber.includes("+91")) {
        phoneNumber = `+91${phoneNumber}`;
    }
    const user = await SharedPropsService.getUser();
    user.linkedBorrowerAccounts[0].accountHolderPhoneNumber = phoneNumber;
    await SharedPropsService.setUser(user);
    await setDatastore(ROUTE.MF_FETCH_PORTFOLIO, action.payload.targetWidgetId, {
        subTitle: phoneNumber.substring(3),
    });
    await goBack();
};
export const phoneOnChange = async (action, _datastore, {}) => {
    phoneNumber = action.payload.value;
};
